module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CT",
    attrs: {
      "id": "_idParaDest-4"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }, [_vm._v("This account is fiction, populated by characters who speak to the realities that women have long lived in silence. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Shame and isolation thrive in that silence. If it isn’t broken, this story will continue to repeat itself.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("I dedicate this book to those who have spoken out.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-437a420f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780802157409-3.vue
// module id = 72
// module chunks = 0